import MmenuLight from 'mmenu-light';
import { dom as FontAwesomeDom } from '@fortawesome/fontawesome-svg-core';

var domConfig = {
    elMenu: document.querySelector('.tpl-header-menu'),
    // elSearcher:document.querySelector('.tpl-header-searchform'),
    elSearcher:document.querySelector('form[role="search"].search-form'),
    fontAwesomeInit:false
};

const menu = new MmenuLight(
    domConfig.elMenu,
    '(max-width: 768px)'
);

const drawer = menu.offcanvas({
    // Uwzglednij wpadminbar
    top:document.querySelector('html')?document.querySelector('html').offsetTop:0
});

// Podpięcie menu.
menu.menu && menu.menu.querySelector('A') && (
    menu.navigation({
        backgroundColor:'var(--wp--preset--color--primary-2)',
        color:'var(--wp--preset--color--primary-complement)',
    })
);
    
        
        
        
//Dodanie wyszukiwarki do menu
menu.toggler.add(() => {
    if(!domConfig.elSearcherMarker) {
        domConfig.elSearcherMarker = document.createComment('original searcher location');
        domConfig.elSearcher.parentElement.insertBefore(domConfig.elSearcherMarker,domConfig.elSearcher);
    }
    drawer.content.append(domConfig.elSearcher);
}, () => {
    if(domConfig.elSearcherMarker) {
        domConfig.elSearcherMarker.after(domConfig.elSearcher);
    }
});


// //Rozszerz metody drawera tab by status był przekazywany do js
// const updateAlpineLayoutRwdMenu = (state) => {
//     if(window.Alpine && window.Alpine.store) {
//         var layout = window.Alpine.store('layout')||{};
//         layout.rwdMenuState = state;
//         window.Alpine.store('layout',layout);
//     }    
// }
// (function(cb){
//     drawer.open = function() {
//         cb.call(drawer);
//         updateAlpineLayoutRwdMenu('open');
//     }
// })(drawer.open);

// (function(cb){
//     drawer.close = function() {
//         cb.call(drawer);
//         updateAlpineLayoutRwdMenu('close');        
//     }
// })(drawer.close);




document.addEventListener('DOMContentLoaded', function(){
    document.querySelector('.tpl-header-hamburger-container button')
                .addEventListener('click', (e) => {
                    e.preventDefault();
                    drawer.open();
                    if(!domConfig.fontAwesomeInit) {
                        domConfig.fontAwesomeInit = true;
                        FontAwesomeDom.i2svg();
                    }
                }); 
});

